import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Home from "@/pages/Home";
import ProjectDetail from "@/pages/ProjectDetail";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminPortfolioList from "@/pages/AdminPortfolioList";
import AdminPortfolioEditor from "@/pages/AdminPortfolioEditor";
import AdminMessages from "@/pages/AdminMessages";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

function PublicShell({ children }) {
    return (
        <>
            <Navbar />
            {children}
            <Footer />
        </>
    );
}

function AppRoutes() {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");

    return (
        <>
            <ScrollToTop />
            <Routes>
                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route
                    path="/admin"
                    element={
                        <ProtectedRoute>
                            <AdminLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Navigate to="portfolio" replace />} />
                    <Route path="portfolio" element={<AdminPortfolioList />} />
                    <Route path="portfolio/new" element={<AdminPortfolioEditor />} />
                    <Route path="portfolio/:slug" element={<AdminPortfolioEditor />} />
                    <Route path="messages" element={<AdminMessages />} />
                </Route>

                {/* Public */}
                <Route
                    path="/"
                    element={
                        <PublicShell>
                            <Home />
                        </PublicShell>
                    }
                />
                <Route
                    path="/portfolio/:slug"
                    element={
                        <PublicShell>
                            <ProjectDetail />
                        </PublicShell>
                    }
                />
            </Routes>
            <Toaster
                position={isAdmin ? "top-right" : "bottom-right"}
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#151618",
                        color: "#F7F5F0",
                        border: "1px solid #2A2A2A",
                        borderRadius: "2px",
                    },
                }}
            />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <AppRoutes />
                    </AuthProvider>
                </BrowserRouter>
            </HelmetProvider>
        </div>
    );
}

export default App;
